import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import AddressForm from './AddressForm';
import PopUp from 'react/shared/components/popups/PopUp';
import PreviousPageButton from 'react/shared/components/true_link/main/form/wizard/PreviousPageButton';
import schema from 'react/shared/utils/schemas';
import addressShape from 'react/signups/card/shapes/AddressShape';

export default function EditAddressModal({
  address,
  headerText,
  onBack,
  onDone,
  showPoBoxWarning,
}) {
  const validationSchema = Yup.object().shape({
    address: schema.address.required(),
  });

  const handleDone = (values) => {
    onDone({
      address: values.address,
    });
  };

  return (
    <PopUp header={headerText} headerComponent={'h2'} hideDismissButton openModal padding="30px">
      <PreviousPageButton desktopOnly onBack={onBack} />
      <Formik initialValues={address} onSubmit={handleDone} validationSchema={validationSchema}>
        {({ setValues, handleSubmit, setFieldTouched, values }) => (
          <AddressForm
            onContinue={handleSubmit}
            setFieldTouched={setFieldTouched}
            setValues={setValues}
            showPoBoxWarning={showPoBoxWarning}
            values={values}
          />
        )}
      </Formik>
    </PopUp>
  );
}

EditAddressModal.propTypes = {
  address: addressShape.isRequired,
  headerText: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
  showPoBoxWarning: PropTypes.bool,
};
